import { setItem, getItem, removeItem } from "./storageService";
import logger from "../../logger";

const STORAGE_KEY = "selectedEnvironment";
const DEFAULT_ENV = process.env.NODE_ENV === "production" ? "production" : "staging";

export const saveSelectedEnvironment = async (environment) => {
  try {
    await setItem(STORAGE_KEY, environment);
    logger.debug("Environment saved");
  } catch (error) {
    logger.error("Error saving environment:", error);
  }
};

export const getSelectedEnvironment = async () => {
  try {
    const environment = await getItem(STORAGE_KEY);
    return environment || DEFAULT_ENV;
  } catch (error) {
    logger.error("Error retrieving environment:", error);
    return DEFAULT_ENV;
  }
};

export const clearSelectedEnvironment = async () => {
  try {
    await removeItem(STORAGE_KEY);
    logger.debug("Environment cleared");
  } catch (error) {
    logger.error("Error clearing environment:", error);
  }
};
